Monitoring.Views ||= {}

class Monitoring.Views.RuleGeneralEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/rules/rule_general_edit"]

  events:
    'change #rule-name'           : 'onChangeName'
    'change #rule-description'    : 'onChangeDescription'
    'change #rule-active'         : 'onChangeActive'
    'change #rule-start-date'     : 'onChangeStartDate'
    'change #rule-end-date'       : 'onChangeEndDate'
    'change #automatic-priority'  : 'onChangePriority'

  initialize: (@options = {}) ->
    @rule = @options.rule

  render: =>
    @$el.html(@template(@))
    @initializeToggle()
    @initializeDatepicker(@rule.get('start_date'), @rule.get('end_date'))
    @initializePrioritySlider()
    @

  initializeToggle: ->
    @$el.find('#rule-active').bootstrapToggle({
      # 'on' and 'off' options can be set here
    })

  initializeDatepicker: (startDate, endDate) ->
    @$el.find('#rule-start-date').datepicker({
      todayBtn: 'linked',
      autoclose: true,
    })
    if startDate
      @$el.find('#rule-start-date').datepicker('setDate', new Date(startDate))

    @$el.find('#rule-end-date').datepicker({
      autoclose: true,
    })
    if endDate
      @$el.find('#rule-end-date').datepicker('setDate', new Date(endDate))

  initializePrioritySlider: =>
    if @hasPriority()
      @$el.find('#automatic-priority').simpleSlider(
        range: [1, 10], snap: true, step: 1
      ).bind('slider:changed', (e, data) => @$el.find('#priority-number').text(data.value));

  hasPriority: =>
    !!@rule.get('priority')

  onChangeName: (evt) ->
    @onChangeTextProperty('name')
    @trigger('changed-mandatory-field')

  onChangeDescription: (evt) ->
    @onChangeTextProperty('description')
    @trigger('changed-mandatory-field')

  onChangeActive: (evt) ->
    active = @$el.find('#rule-active').prop('checked')
    @rule.set('active', active)

  onChangeStartDate: (evt) ->
    date = @$el.find('#rule-start-date').datepicker("getDate")
    @rule.set('start_date', date)
    @trigger('changed-mandatory-field')

  onChangeEndDate: (evt) ->
    date = @$el.find('#rule-end-date').datepicker("getDate")
    @rule.set('end_date', date)

  onChangeTextProperty: (propertyName) ->
    enteredProperty = @$el.find("#rule-#{propertyName.replace('_', '-')}").val().trim()
    @rule.set(propertyName, enteredProperty)

  onChangePriority: (evt) =>
    priority = @$el.find('#automatic-priority').val()
    @rule.set('priority', priority)

  allMandatoryFieldsAreFilled: =>
    @nameIsFilled() and @startDateIsFilled()

  nameIsFilled: ->
    @$el.find('#rule-name').val().trim().length > 0

  startDateIsFilled: ->
    @$el.find('#rule-start-date').val().trim().length > 0
